import $ from 'jquery';

export default function () {
	let win = $(window), html = $('html'), timeout = false;

	win.on("scroll", function () {
		if(!timeout) {
			timeout = true;
			setTimeout(onScroll, 50);
		}
	});

	setTimeout(onScroll, 50);

	function onScroll() {
		timeout = false;
		$('.reveal:not(.revealed)').each(function () {
			if(isVisible(this)) {
				$(this).addClass('revealed');
			}
		});
	}

	function isVisible(el) {
		let elemTop = el.getBoundingClientRect().top;
		let elemBottom = el.getBoundingClientRect().bottom;
		return (elemBottom >= 0) && (elemTop <= window.innerHeight);
	}
};